import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import {ViewerCanvas} from "./viewer/ViewerCanvas";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(window.location.hash === '#sandbox'
  ? <div>
    <style>{`html, body { margin: 0; padding: 0; }`}</style>
    <ViewerCanvas url={'http://localhost:5113/ring.stl'}/>
  </div>
  : <App/>
);
